<mat-card appearance="outlined">
  <mat-card-title>
    <ui-svg-icon [name]="iconNames.CircleSegment" [width]="32" class="tw-align-middle"></ui-svg-icon>
    {{ title | translate }}
  </mat-card-title>
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
